import { UserPreferenceContext } from '@contexts/user-preference-context';
import { Icon, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface MenuProps {
  isLeftIcon?: string;
  itemKey: string;
  navUrl?: string;
  urlMatcherRegex?: RegExp;
  showWithText?: boolean;
  children?: any;
  showChildren?: boolean;
  isChild?: boolean;
  idValue?: string;
  dataClick?: boolean;
  iconOnlyItem?: boolean;
  textOnly?: boolean;
  className?: string;
  displayLink?: boolean;
  iconCustomClass?: string;
}

const MenuItem: React.FC<MenuProps> = (props) => {
  const {
    showWithText,
    textOnly,
    children,
    isLeftIcon,
    itemKey,
    iconOnlyItem,
    className,
    displayLink,
    iconCustomClass = '',
  } = props;
  const { t } = useTranslation();

  let isActive =
    props.urlMatcherRegex &&
    props.urlMatcherRegex.test(window.location.pathname);
  const [toggle, setToggle] = useState(
    props.showChildren || (children && isActive),
  );
  const navigate = useNavigate();
  const { userPreference } = useContext(UserPreferenceContext);

  const navigateUrl = (event) => {
    event.preventDefault();
    isActive = true;
    showWithText && setToggle(!toggle);
    if (props.navUrl && ((children && !showWithText) || !children)) {
      navigate(
        props.navUrl.replace(
          'td/',
          `/td/${userPreference?.preference?.projectPreference?.versionId}/`,
        ),
      );
    }
  };

  const containerClasses = classNames(
    !children && isActive && '!bg-unique-1000 text-unique-600 !font-normal',
    children && isActive && 'hover:!bg-unique-1000 text-unique-600',
    !isActive && 'hover:!bg-unique-1000 text-unique-600',
    itemKey && showWithText
      ? (!props?.isChild ? 'px-[9px]' : 'pl-[20px] pr-[5px] !mb-[2px]') +
          ' py-[9px] basis-full'
      : !iconOnlyItem
      ? 'px-[9px] py-[5px] basis-full'
      : '',
    textOnly && !showWithText && 'mb-sm',
    !showWithText && !iconOnlyItem && 'w-9 h-9 !mb-0',
    !showWithText && children && isActive && 'bg-[#e2e7ee]',
    children && !toggle && isActive && 'bg-[#e2e7ee] text-unique-600',
    'flex items-center text-[13px] rounded cursor-pointer leading-1.2 font-normal transition ease-in duration-100 relative w-full',
    className,
  );

  const iconClasses = classNames(
    itemKey && showWithText ? 'pr-[10px] text-[20px]' : 'text-[20px]',
  );
  const linkUrl =
    props.navUrl &&
    ((children && !showWithText) || !children) &&
    displayLink &&
    props.navUrl.replace(
      'td/',
      `/td/${userPreference?.preference?.projectPreference?.versionId}/`,
    );

  return (
    <>
      {linkUrl ? (
        <Link to={linkUrl} className='w-full'>
          <div
            id={props?.idValue ? props?.idValue : ''}
            data-beamer-click={props?.dataClick ? props?.dataClick : ''}
            data-pathname={window.location.pathname}
            data-is-active={props.urlMatcherRegex?.test(
              window.location.pathname,
            )}
            data-nav-url={props.navUrl}
            onClick={(e) => navigateUrl(e)}
            className={containerClasses}
          >
            {isLeftIcon ? (
              <Icon
                className={classNames(
                  iconClasses,
                  iconCustomClass,
                  'text-unique-800',
                )}
                name={isLeftIcon}
              />
            ) : !textOnly ? (
              <div className='mr-[20px]' />
            ) : null}
            {itemKey && showWithText && <span>{t(itemKey)}</span>}
            {children && showWithText && (
              <Icon
                className={classNames(
                  iconCustomClass,
                  'text-lg block mr-auto ease-linear transform transition duration-200',
                  {
                    'rotate-180': toggle,
                  },
                )}
                name='angle-bottom'
              />
            )}
          </div>
        </Link>
      ) : (
        <div
          id={props?.idValue ? props?.idValue : ''}
          data-beamer-click={props?.dataClick ? props?.dataClick : ''}
          data-pathname={window.location.pathname}
          data-is-active={props.urlMatcherRegex?.test(window.location.pathname)}
          data-nav-url={props.navUrl}
          onClick={(e) => navigateUrl(e)}
          className={containerClasses}
        >
          {isLeftIcon ? (
            <Icon
              className={classNames(
                iconClasses,
                iconCustomClass,
                'text-unique-800',
              )}
              name={isLeftIcon}
            />
          ) : !textOnly ? (
            <div className='mr-[20px]' />
          ) : null}
          {itemKey && showWithText && <span>{t(itemKey)}</span>}
          {children && showWithText && (
            <Icon
              className={classNames(
                'text-lg block ml-auto ease-linear transform transition duration-200',
                {
                  'rotate-180': toggle,
                },
              )}
              name='angle-bottom'
            />
          )}
        </div>
      )}

      {showWithText && toggle && children ? (
        <div className='flex flex-wrap transition ease-in duration-500 overflow-hidden w-full'>
          {children}
        </div>
      ) : null}
    </>
  );
};

export default MenuItem;
